import * as _ from "lodash";

export const hasMultipleKeys = _.overArgs(_.every, [
  _.identity,
  _.curry(_.has),
]);
